// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionsCarousel-cls1_SoM","cls2":"SuggestionsCarousel-cls2_yxO SuggestionsCarousel-cls1_SoM"};